module.exports = __webpack_public_path__ + "img/stock2.7511bb4a.png";